import { useState } from "react";
import {
  EuiFilterButton,
  EuiFilterGroup,
  EuiSelectable,
  EuiPopoverTitle,
  EuiCheckbox,
  EuiBadge,
  EuiNotificationBadge,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiButton,
} from "@elastic/eui";
import Button from "components/Buttons/Button";
import Popover from "components/Popover/Popover";
import { useCompareDropdownStyles } from "../../../Performance/Activity_V2/Compare/CompareDropdownStyles";

export const SelectDropdown = ({
  selectedItem,
  options,
  setOptions,
  setSelectedItem,
  onChange,
  width = 300,
  isLoading,
  singleSelection = true,
  searchable = false,
  onApply = () => {},
}: any) => {
  const classes = useCompareDropdownStyles();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const onButtonClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const closePopover = () => {
    setIsPopoverOpen(false);
  };

  const count = options?.filter((i) => i.checked === "on")?.length;

  const button = (
    <EuiFilterButton
      isLoading={isLoading}
      iconType="arrowDown"
      badgeColor="accent"
      css={{ minWidth: "300px", width: "100%", maxWidth: "300px" }}
      onClick={onButtonClick}
      isSelected={isPopoverOpen}>
      {singleSelection ? selectedItem : "Categories"}

      {!singleSelection && count > 0 && (
        <EuiNotificationBadge style={{ marginLeft: "4px" }}>
          {count > 0 ? count : ""}
        </EuiNotificationBadge>
      )}
    </EuiFilterButton>
  );

  return (
    <>
      <EuiFilterGroup>
        <Popover
          button={button}
          isOpen={isPopoverOpen}
          onClose={closePopover}
          panelPaddingSize="none"
          children={
            <div>
              <EuiSelectable
                className={classes.mySelectable}
                allowExclusions={false}
                singleSelection={singleSelection}
                listProps={{ showIcons: false }}
                searchable={searchable}
                height={options?.length <= 8 ? options?.length * 32 : 220}
                searchProps={{
                  placeholder: "",
                  compressed: false,
                  css: {
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    borderBottom: ".6px solid var(--border-color)",
                    boxShadow: "none",
                    backgroundColor: "var(--card-background)",
                  },
                }}
                renderOption={(option) => {
                  const isChecked = option.checked === "on";
                  if (option?.label?.includes("Select")) {
                    return (
                      <div className={classes.checkboxLabel}>
                        <span style={{ color: "#8ea0bd" }}>{option.label}</span>
                      </div>
                    );
                  }
                  return (
                    <div className={classes.optionRow}>
                      <EuiCheckbox
                        id={`checkbox_${option.label}`}
                        checked={isChecked}
                        onChange={() => {}}
                        onClick={(e) => {
                          e.stopPropagation();

                          if (singleSelection) {
                            setSelectedItem(option.label);
                            setOptions(
                              options.map((i, index) => ({
                                ...i,
                                checked: i.label === option.label ? "on" : "",
                              }))
                            );
                            onButtonClick();
                          } else {
                            const newOptions = options.map((i) => ({
                              ...i,
                              ...(i.label === option.label && {
                                checked: option.checked === "on" ? "" : "on",
                              }),
                            }));

                            setOptions(newOptions);
                          }
                        }}
                        label={
                          <div className={classes.checkboxLabel}>
                            <span>{option.label}</span>
                          </div>
                        }
                      />
                    </div>
                  );
                }}
                aria-label="Data list"
                options={options}
                onChange={(newOptions) => {
                  onChange();
                }}
                loadingMessage="Loading data"
                emptyMessage={"No data"}
                noMatchesMessage="No data found">
                {(list, search) => (
                  <div style={{ width }}>
                    <EuiPopoverTitle paddingSize="s">{search}</EuiPopoverTitle>
                    {list}
                  </div>
                )}
              </EuiSelectable>
              {!singleSelection && (
                <>
                  <EuiSpacer size="s" />
                  <EuiFlexGroup
                    gutterSize="m"
                    justifyContent="flexEnd"
                    style={{
                      padding: "8px",
                      backgroundColor: "var(--app-background)",
                      borderRadius: "0 0 6px 6px",
                    }}>
                    <EuiFlexItem grow={false}>
                      <Button type="secondary" onClick={closePopover} text="Cancel" />
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                      <Button
                        type="primary"
                        text="Apply"
                        onClick={() => {
                          onApply();
                          closePopover();
                        }}
                      />
                    </EuiFlexItem>
                  </EuiFlexGroup>
                </>
              )}
            </div>
          }
        />
      </EuiFilterGroup>
    </>
  );
};
